import { Trash } from "@phosphor-icons/react";
import { Button, Dialog, Flex } from "@radix-ui/themes";

import { useAppSelector } from "../../../utils/hooks";

type DeleteTicketDialogProps = {
  ticketId?: string;
  onDelete(ticketId: string): void;
  onCancel(): void;
  isPending: boolean;
};

export function DeleteTicketDialog(props: DeleteTicketDialogProps) {
  const { isPending, onCancel, onDelete, ticketId } = props;
  const tickets = useAppSelector((state) => state.punttProjects.tickets);
  const ticket = useAppSelector((state) => state.ticket.value);

  const found = ticket ?? tickets.find((t) => t._id === ticketId);

  return (
    <Dialog.Root open={ticketId != null}>
      <Dialog.Content maxWidth="450px">
        <Dialog.Title>Delete project?</Dialog.Title>
        <Dialog.Description>
          Are you sure you want to delete <em>{found?.title}</em>?
        </Dialog.Description>

        <Flex gap="2" mt="3" justify="end">
          <Button variant="soft" color="gray" onClick={() => onCancel()}>
            Cancel
          </Button>
          <Button
            color="red"
            onClick={() => onDelete(ticketId as string)}
            disabled={isPending}
            loading={isPending}
          >
            <Trash />
            Delete
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
